import wixLocationFrontend from 'wix-location-frontend'
import wixSeoFrontend from 'wix-seo-frontend'
import { getSiteDisplayName } from 'wix-site-frontend'
import { getAuthorDetials } from '@wix-platform/blog-cross-posts-backend'

export async function setAuthorLink($linkElement) {
    const post = await $w('#post').getPost()

    const { name, link } = await getAuthorDetials(post.author)

    switch ($linkElement.type) {
        case '$w.Text':
            linkTextElement($linkElement, name, link)
            break
        case '$w.Button':
            $linkElement.label = name
            $linkElement.link = link
            break
    }

    if ($linkElement.type === '$w.Text') {
        linkTextElement($linkElement, name, link)
    } else {
        $linkElement.label = name
        $linkElement.link = link
    }

    await setPostStructuredData(post, name, link)
}

const linkTextElement = ($element, text, link, newTab = false) => {
    $element.text = text
    const target = (newTab) ? '_blank' : '_self'
    const linkedText = `<a href="${link}" target="${target}">${text}</a>`
    $element.html = $element.html.replace(text, linkedText)
}


function setPostStructuredData(post, authorName, authorUrl) {
    const { publishedDate, lastPublishedDate, title, excerpt, postPageUrl, coverImage } = post
    const { baseUrl } = wixLocationFrontend
    const postUrl = `${baseUrl}${postPageUrl}`

    const imageData = getImageData(coverImage)

    const blogPostStructuredData = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        "author": {
            "@type": "Person",
            "name": authorName,
            "url": authorUrl,
        },
        "dateModified": lastPublishedDate,
        "datePublished": publishedDate,
        "headline": title,
        "mainEntityOfPage": {
            "@id": postUrl,
            "@type": "itemPage",
            "url": postUrl,
        },
        "description": excerpt,
        "url": postUrl,
        "image": {
            "@type": "ImageObject",
            "url": imageData.url,
            "width": imageData.width,
            "height": imageData.height
        },
        "publisher": {
            "@type": "Organization",
            "name": getSiteDisplayName(),
            "url": baseUrl
        }
    }

    return wixSeoFrontend.setStructuredData([blogPostStructuredData])
}

const getImageData = (image) => {
    const [, fileName, width, height] = image.match(/(?:wix:image:\/\/v\d+\/)([a-zA-Z0-9_~]+\.jpg).*#originWidth=(\d+)&originHeight=(\d+)/)
    const url = `https://static.wixstatic.com/media/${fileName}`
    return { fileName, url, width, height }
}